import {
  GetRepairRequest,
  PostRepairRequest,
  PostRepairRequestQc,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface RepairRequestParams {
  rmaNo: string;
}

const endPoint = 'repair-request';

export const getRepairRequest = async (
  params: RepairRequestParams,
): Promise<GetRepairRequest> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });
  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const postRepairRequest = async (
  newRequest: PostRepairRequest | PostRepairRequestQc,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(newRequest),
    contentType: 'application/json',
  });
  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteRepairRequest = async (rmaNo: string): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });
  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
